import React from "react";
import { observer } from "mobx-react-lite";
import { TextField, Button, Typography, CircularProgress } from '@material-ui/core';
import logoWide  from './logo-wide.png';


export const Login = observer(({ model, theKey }) => {
  const [emailValid, setEmailValid] = React.useState(false);
  
  if (model.loginStatus === 'LOGIN_OK') {
    return null;
  }
  if (model.loginStatus === 'LOGIN_FAILED') {
    return (
      <div style={{margin: '2em'}}>
        <div style={{marginBottom: '1em'}}> 
          Access denied, likely an invalid key: {theKey}
        </div>
        <div>
          Please try to access the preview again.  If that fails, please contact info@lawtomata.com.
          Be sure to include the access key above.
        </div>
      </div>);
  }
  if (theKey && model.loginStatus !== 'KEY_SENT') { // check the key
    model.login(theKey);
    return (
      <div>
        Logging in with key: {theKey}
        <CircularProgress /> 
      </div>
    );
  }
  
  //console.log('Not logged in', window.location.href, theKey, toJS(model));
  return (
    <div style={{margin: '3em', display: 'flex', justifyContent: 'center'}}>
      <div style={{width: 600, border: '1px solid black', padding: '2em', borderRadius: '5px'}}>
        <div style={{display: 'flex', justifyContent: 'space-around',
                     alignItems: 'center', marginBottom: '1em'}}>
          <img src={logoWide} width={200} alt="Lawtomata Logo"  /> 
          <Typography variant="h4" align='center' >
          ClaimWorkShop Preview
          </Typography>
        </div>
        <Typography variant="body1" display="block" >
          To access the preview, please provide a valid email address.  No commitment,
          no credit card required.  We'll send you a link to get you on your way.
        </Typography>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1.0em'}}>
          <TextField
            id='email_addr_field'
            disabled={Boolean(model.loginStatus)}
            variant="outlined" style={{width: "80%"}}
            label="Email address"
            value={model.user ? model.user.email : ''}
            onChange={(e) => {
              const addr = e.target.value.toLowerCase();
              model.setUser({email: addr});
              const re = /^[^@]+@[^@]+\.[^@]+$/;
              setEmailValid(re.test(addr));
            }}
            />
            {/*{model.user}*/}
          <Button
            type="submit"
            variant="contained" color="primary"
            disabled={Boolean(model.loginStatus) || !emailValid}
            onClick={() => model.login(theKey)}
          >
            Go
          </Button>
        </div>
        
        <Typography variant="body2">
          {model.loginStatus === 'EMAIL_SENT' ?
           <span style={{fontWeight: 'bold'}}>Email sent. Please check your inbox for the login link.</span> : null }
        </Typography>
        <Typography variant="body2" display="block">
          {emailValid ? "Email address looks good." : "Enter a valid email address."}
          {/*model.user && model.user.key ? 'Key: ' + model.user.key : ''*/}
        </Typography>
        <Typography variant="body2" display="block" paragraph={true}>
          Server status: {model.connected ?
                          <span style={{color: 'green'}}>Up</span> :
                          <span style={{color: 'red'}}>Down</span>}
        </Typography>
        <Typography variant="body2" display="block">
          We may use your email address to contact you for marketing purposes or send you occasional 
          updates regarding Lawtomata's products.  You will be able to opt out at any time.
          We will never share your email address.
        </Typography>
      </div>
    </div>
  );
});
